'use client';

import { useEffect } from 'react';
import { useRouter } from '@/i18n/navigation';
import { useAuth } from '@/contexts/AuthContext';
import dynamic from 'next/dynamic';
import HomePageLoadingShell from '@/components/home/HomePageLoadingShell';
import { DashboardProvider } from '@/contexts/DashboardContext';

const CreateProjectPage = dynamic(() => import('@/components/home/CreateProjectPage'), {
  ssr: false,
  loading: () => <HomePageLoadingShell />,
});

/**
 * / — Root page.
 * Authenticated users are redirected to /dashboard.
 * Unauthenticated users see the prompt/create page (with login prompt).
 */
export default function HomePage() {
  const { user, isLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!isLoading && user) {
      router.replace('/dashboard');
    }
  }, [user, isLoading, router]);

  if (isLoading || user) return null;
  return (
    <DashboardProvider>
      <CreateProjectPage />
    </DashboardProvider>
  );
}
